import styled from "@emotion/styled";
import React from "react";
import { AppIcon } from "./Generic/AppIcon";

interface Props {
  icon: JSX.Element;
  size?: number;
  color?: string;
  fill?: string;
  stroke?: string;
}

function CircleIcon(props: Props) {
  return (
    <CircleIcon.Wrapper {...props}>
      <AppIcon icon={props.icon} fill={props.fill} stroke={props.stroke} />
    </CircleIcon.Wrapper>
  );
}

CircleIcon.Wrapper = styled.div<{ size?: number; color?: string; fill?: string; stroke?: string }>`
  --size: ${(props) => props.size ?? 40}px;
  --background-color: ${(props) => props.color ?? "var(--primary-color)"};
  color: ${(props) => props.fill ?? props.stroke ?? "var(--primary-color)"};
  background: var(--background-color, var(--primary-color));
  width: var(--size);
  height: var(--size);
  border-radius: var(--size);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default CircleIcon;
